module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Rose Gold + Lavender Closed.aad4e851.png";